import { Grid } from "@material-ui/core";
import { Field } from "modules/app/components/ContactDetails/Details/styles";
import React from "react";

function NameRule({ attributes, setAttributes, errors }) {
  return (
    <Grid container alignItems="center" spacing={1}>
      <Grid item style={{ textAlign: "right", width: "20%" }}>
        Nome
      </Grid>

      <Grid item style={{ width: "50%" }}>
        <Field
          value={attributes.name}
          label={!attributes.name && "Nome"}
          variant="outlined"
          helperText={errors.name}
          onChange={(e) =>
            setAttributes({
              ...attributes,
              name: e.target.value,
            })
          }
        />
      </Grid>
    </Grid>
  );
}

export default NameRule;
